import { constantes } from '../../constantes';
import { ParamsService } from '../../services/params.service';
import { Company } from '../../interfaces/company.interface';
import { DataService } from '../../services/data.service';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-page-company',
  templateUrl: './page-company.component.html',
	styleUrls: ['./page-company.component.scss']
})
export class PageCompanyComponent implements OnInit, AfterViewInit {

	@ViewChild('formFilter') formFilter:ElementRef;
	@Input() companies:Company[];

	constantes:any = constantes;

	letters:{label:string, value:string}[] = [];
	alphabet:string = 'abcdefghijklmnopqrstuvwxyz';
	filterOpen:boolean;
	activities:{}[];

	form:FormGroup;
	subtry:boolean;



  constructor(
		private _fb:FormBuilder,
		private hostElement:ElementRef,
		public breakpointObserver: BreakpointObserver,
		public dataService:DataService,
    private paramsService:ParamsService,
    private route: ActivatedRoute,
	) {

	}


  ngOnInit() {

		let validation:any = Validators.compose([Validators.required]);

		let len:number = this.alphabet.length;
		for(let i=0;i<len;i++){;
			let char:string = this.alphabet.charAt(i);
			this.letters.push({label: char.toUpperCase(), value: char});
		}

		let mobile:boolean = this.breakpointObserver.isMatched('(max-width: 768px)');
		this.filterOpen = !mobile;

		this.breakpointObserver
		.observe(['(max-width: 768px)'])
		.subscribe((state: BreakpointState) => {
			if (!state.matches) this.filterOpen = true;
			else this.filterOpen = false;
		});

    //this.dataService.resetSelectedSectors(this.constantes.sectors);


		this.form = this._fb.group({
			name: ['', validation],
			activity: ['', validation],
			sector: ['', validation],
			firstLetter: ['', validation],
			peps: ['', validation],
			cles: ['', validation],
		});

		this.form.valueChanges.subscribe(
			resp => {
				this.dataService.filterCompany(resp);
			},
			err => {},
    );


    let urlParamFilter = this.route.snapshot.paramMap.get("arg");
    if(urlParamFilter){
      let args = urlParamFilter.split(',');
      if(args.indexOf('peps') > -1) this.form.controls['peps'].setValue(true);
      if(args.indexOf('cles') > -1) this.form.controls['cles'].setValue(true);
    }


		if(this.dataService.companies) this.init();
		else this.paramsService.addListener('data_change', () => {
			this.init();
		});
	}


	init():void
	{
		this.dataService.filterCompany(this.form.value);

		let domains:string[] = this.dataService.companies.map(a => a.domain);
		domains = domains.filter(item => (item) ? true : false);
		domains = domains.filter((value, index, self) => {
			return self.indexOf(value) === index;
		});

		this.activities = domains.map(a => ({label:a, value:a}));

	}







	ngAfterViewInit():void
	{
		this.formFilter.nativeElement.style.display;
		//style empty
		//style = only when set directly on the element...
		//how to get calculated style (from every selector)



	}


	clickSector(id:string){

		if(id == 'all') this.dataService.resetSelectedSectors(this.constantes.sectors);
		else this.dataService.toggleSelectedSector(id);
	}


	clickHelp(id:string):void
	{
		//debugger;
	}

	toggleFilter()
	{
		this.filterOpen = !this.filterOpen;

	}

	onLocalize(item:Company):void
	{
		item.rubric = 'entreprises';
		this.paramsService.dispatch('localize', item);
	}


}
